import React from 'react';
import { Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import * as S from './styles';

export function Content() {
	return (
		<S.Wrapper>
			<Col span={24}>
				<S.Title>Priority</S.Title>
			</Col>
			<Col span={24}>
				<span className="low">0 - {I18n.get('Low priority')}</span>
			</Col>
			<Col span={24}>
				<span className="medium">1 - {I18n.get('Medium priority')}</span>
			</Col>
			<Col span={24}>
				<span className="high">2 - {I18n.get('High priority')}</span>
			</Col>
		</S.Wrapper>
	);
}
